import '@total-typescript/ts-reset';
import Header from 'modules/Header';
import { AppRoutes } from './AppRoutes';
import './styles/index.css';
import Loadable from 'react-loadable';
import { Outlet } from 'react-router-dom';
import {
	appGlobalInit,
	getAppData,
	togglePageMainToolNavigationTransitionedClass,
} from '../../../../ReactSharedScripts/modules/app/utils';
import { hasToolNavigation } from '../../../../ReactSharedScripts/modules/toolNavigation/hasToolNavigation';
import { EntityTypeIds, useUserPageContextState } from '../../../../ReactSharedScripts/modules/user';
import { HAS_PRODUCTION_PLATFORM_LABEL } from '../../../../ReactSharedScripts/const/env';
import { useAppHooks } from '../../../../ReactSharedScripts/modules/app/hooks/useAppHooks';
import { CookieAcceptPortal } from '../../../../ReactSharedScripts/modules/app/components/CookieAccept';
import { NotificationsPortal } from '../../../../ReactSharedScripts/components/Notifications';
import { AppProviders } from '../../../../ReactSharedScripts/modules/app/AppProviders';
import { Footer } from '../../../../ReactSharedScripts/modules/footer/Footer';
import { ToolNavigation } from '../toolNavigation/ToolNavigation';
import { useEffect } from 'react';
import { Maintenance } from '../../../../ReactSharedScripts/components/Maintenance/Maintenance';
import { OutdatedApp } from '../../../../ReactSharedScripts/modules/unhandledRejection/outdatedApp/OutdatedApp';

appGlobalInit();

const LoadableProductionLabelMark = Loadable({
	loader: () =>
		import('../../../../ReactSharedScripts/components/ProductionLabelMark').then(
			(module) => module.ProductionLabelMark,
		),
});

function useLayoutHook() {
	useEffect(() => {
		setTimeout(() => {
			togglePageMainToolNavigationTransitionedClass(true);
		}, 700);
	}, []);
}

function AppInner() {
	const { isIframeMode, userIsAuthenticated } = getAppData();
	const { organizationTypeId } = useUserPageContextState();
	const showProductionLabel = HAS_PRODUCTION_PLATFORM_LABEL && organizationTypeId === EntityTypeIds.PLATFORM_USER;

	useAppHooks();
	useLayoutHook();

	return (
		<>
			{hasToolNavigation() && (
				<div
					className='app__tool-nav tool-navigation-wrapper'
					id='app__tool-nav'
				>
					<ToolNavigation />
				</div>
			)}

			<div className='app__body'>
				{!isIframeMode && (
					<div className='app__body-header app__body-header--sticky'>
						<Header />
					</div>
				)}
				<div className='app__body-main'>
					<AppRoutes />
					<Outlet />
				</div>
				<Maintenance />
				<CookieAcceptPortal />
				<NotificationsPortal />
				<OutdatedApp />
				{!userIsAuthenticated && !isIframeMode && <Footer />}
				{showProductionLabel && <LoadableProductionLabelMark />}
			</div>
		</>
	);
}

function App() {
	return (
		<AppProviders>
			<AppInner />
		</AppProviders>
	);
}

export { App };
